import {ApiClient} from '@hconnect/apiclient'
import {spawnErrorToast, spawnSuccessToast} from '@hm/fundamental'
import {useMutation, useQueryClient} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useTranslation} from 'react-i18next'

import {TasksApiPath, FEATURE_NAMESPACE} from '../../../consts'
import {TasksQueryKey} from '../useTasks'

import {ProcessWorkOrderQueryKey} from './useProcessWorkOrder'

interface DeactivateProcessWorkOrderParams {
  plantId: string
  scheduleId: string
  state: string
}

export const useDeactivateProcessWorkOrderSeries = () => {
  const queryClient = useQueryClient()
  const {t} = useTranslation(FEATURE_NAMESPACE)

  return useMutation<boolean, AxiosError, DeactivateProcessWorkOrderParams>({
    mutationFn: async ({plantId, scheduleId, state}) => {
      const path = `${TasksApiPath.PROCESS_WORK_ORDERS}/${plantId}/process-work-order-schedules/${scheduleId}/state`
      const {data} = await ApiClient.axiosInstance.patch<{data: boolean}>(path, {state})
      return data.data
    },

    onError: () => {
      spawnErrorToast(t('processWorkOrders.message.failedToDeleteProcessWorkOrderSeries'))
    },

    onSuccess: async () => {
      spawnSuccessToast(t('processWorkOrders.message.processWorkOrderSeriesDeleted'))
      await queryClient.invalidateQueries({
        queryKey: [ProcessWorkOrderQueryKey]
      })
      await queryClient.invalidateQueries({
        queryKey: [TasksQueryKey]
      })
    }
  })
}
